// src/features/menu/menuSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface MenuState {
  menuSelected: string | null;
}

const initialState: MenuState = {
  menuSelected: 'Hospitals',
};

const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    setMenuSelected(state, action: PayloadAction<string>) {
      state.menuSelected = action.payload;
    },
  },
});

export const { setMenuSelected } = menuSlice.actions;
export default menuSlice.reducer;
